module.exports = __webpack_public_path__ + "img/box2-card-02.eaf22812.png";